<template>
  <div class="flat-switch-content" v-show="isEnabledToShow">
    <div class="rows">
      <h2 class="subtitle has-text-weight-bold has-text-primary is-size-5">
        Ativar cotações no modo de validação?
      </h2>
      <div class="flat-switch">
        <p class=" is-size-10 p-switch" > {{ 'Desativado'}}</p>
        <sc-field v-if="reset">
          <sc-switch 
            v-model="status"
            @input="toggleCommit"/>
            
        </sc-field>
        <p class=" is-size-10"> {{ 'Ativo' }} </p>
      </div>
      <sc-collapse>
        <div
            slot="trigger"
            class="panel-heading"
            role="button"
            aria-controls="contentIdForA11y2">
            <sc-icon 
              icon="info-circle" 
              class="additional-information__icon" 
              size="is-small" />
                <strong>O que é isso ?</strong>
        </div>
        <div class="panel-block">
          <p>
            Essa funcionalidade serve para disponibilizar em tempo real a consulta 
            dos detalhes de cotações que foram realizadas fora do TMS. 
            Habilite-a, realize suas cotações fora da plataforma e visualize os detalhes logo em seguida. <br>
            Caso a cotação seja feita aqui no TMS, não é necessário ativar essa funcionalidade, já que o detalhe de todas as cotações são disponibilizadas em tempo real..<br>
          </p>
        </div>
      </sc-collapse>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScSwitch,
  ScField,
  ScCollapse,
  ScIcon,
} from '@intelipost-js/secure-components';


const {
  mapActions,
  mapState,
} = createNamespacedHelpers('quote/freightQuote');

export default {
  name: 'sc-real-time-quotation',
  data() {
    return {
      status: true,
      isEnabledToShow: false,
      reset: true,
    };
  },
  methods: {
    ...mapActions([
      'quoteGetRealtimeStatus',
      'quotegetIsEnableToShowRealtimeQuotation',
      'enableRealtimeDetailQuotationReturn',
      'disableRealtimeDetailQuotationReturn',
    ]),
    toggleCommit(value) {
      if (value) {
        this.enableRealtimeDetailQuotationReturn().then(() => {
          this.status = true;
        }).catch(() => {
          this.status = false;
        });
      } else {
        this.disableRealtimeDetailQuotationReturn().then(() => {
          this.status = false;
        }).catch(() => {
          this.status = true;
        });
      }
    },
  },
  computed: {
    ...mapState([
      'realtimeStatus',
    ]),
  },
  mounted() {
    this.quoteGetRealtimeStatus().then((realtimeStatus) => {
      this.status = realtimeStatus;
    });
    this.quotegetIsEnableToShowRealtimeQuotation().then((isEnabledToShow) => {
      this.isEnabledToShow = isEnabledToShow;
    });
  },
  components: {
    ScSwitch,
    ScField,
    ScCollapse,
    ScIcon,
  },
};
</script>
<style lang="scss" scoped>
  .flat-switch {
    display: flex;
  }
  .p-switch {
      margin-right: 5px; 
  }
  .flat-switch-content {
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 2px 3px hsla(0,0%,4%,.1), 0 0 0 1px hsla(0,0%,4%,.1);
    margin-bottom: 1.5rem;
    padding: 7px;
  }
  .panel-heading {
    background-color: white;
  }
  .additional-information__icon {
    margin-right: 5px;
  }

  .panel-heading strong {
    font-size: 14px
  }

  .panel-heading {
    font-size: 14px;
  }

  .panel-block p i {
    font-size: 8px;
    margin-right: 5px;
  }
</style>





// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-real-time-quotation/ScRealTimeQuotation.vue?5d51cfae